import { clsx } from 'clsx';
import { useDispatch } from 'react-redux';
import { generatePath, useMatch, useNavigate } from 'react-router-dom';

import { useCurrentSupportUser } from '@/features/dashboard-users/hooks/useCurrentSupportUser';

import { useRoutepaths } from '@/router/hooks/useRoutePaths';
import { SearchForm } from '@/ui-kit/header/SearchForm';

import { logout } from '@/store/actions/auth.actions';

import { FavoriteMenu } from './FavoriteMenu';
import { UserMenu } from './UserMenu';
import { LanguageMenu } from './LanguageMenu';

export function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const PathRoute = useRoutepaths();

  const currentSupportUser = useCurrentSupportUser();

  const isPassphraseRoute = useMatch(generatePath(PathRoute.auth.root, { '*': PathRoute.auth.passphrase }));

  const signOut = () => {
    dispatch(logout());
    navigate(generatePath(PathRoute.auth.root, { '*': PathRoute.auth.signIn }));
  };

  const viewAccount = () => {
    navigate(generatePath(PathRoute.app.root, { '*': PathRoute.app.accountOverview }));
  };

  return (
    <div
      className={clsx(
        'flex items-center bg-primary px-6 py-[10px] shadow-100 z-[100] gap-5',
        !!isPassphraseRoute ? 'justify-end' : 'justify-between',
      )}
    >
      {!isPassphraseRoute && <SearchForm />}
      <div className="flex w-fit min-w-[360px] justify-end items-center gap-6">
        <div className="flex items-center gap-3">
          <FavoriteMenu favorites={currentSupportUser?.metadata?.favorites || []} />
          <LanguageMenu />
        </div>
        <UserMenu userName={currentSupportUser.username} onLogout={signOut} onViewAccount={viewAccount} />
      </div>
    </div>
  );
}
